import { render, staticRenderFns } from "./CreateTeams.vue?vue&type=template&id=21a87c00&scoped=true&"
import script from "./CreateTeams.vue?vue&type=script&lang=js&"
export * from "./CreateTeams.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeams.vue?vue&type=style&index=0&id=21a87c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a87c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VContainer,VFadeTransition,VIcon,VRow,VSlideXTransition})
